import type { ApiConstants } from '@/types/auth';

// Define environment-specific constants
const productionConstants: ApiConstants = {
  apiUrl: 'https://testerly.com/api',
  careerMatchesUrl: 'https://testerly.com/careers/matches',
  errorMonitoringUrl: 'https://testerly.com/monitoring',
  sessionCookieDomain: '.testerly.com',
  sessionCookieSecure: 'secure;'    // Indicates the cookie should be sent only over HTTPS
}

const developmentConstants: ApiConstants = {
  apiUrl: 'http://127.0.0.1:8000/api',
  careerMatchesUrl: 'http://127.0.0.1:8000/careers/matches',
  errorMonitoringUrl: 'http://127.0.0.1:8000/monitoring',
  sessionCookieDomain: '127.0.0.1',
  sessionCookieSecure: ''           // Not secure for development
}

// Optional: Use this for debugging from a mobile device on the same network
// const developmentConstantsForMobileSafari: ApiConstants = {
//   apiUrl: 'http://192.168.4.193:8000/api',
//   careerMatchesUrl: 'http://192.168.4.193:8000/careers/matches',
//   sessionCookieDomain: '192.168.4.193',
//   sessionCookieSecure: '',
// };

// Export the appropriate constants based on the environment
export const constants = import.meta.env.MODE === 'production'
  ? productionConstants
  : developmentConstants;